import { Component, OnInit } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ProductCategory } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { Logo } from '../../common/logo/logo';
import { SiteName } from '../../common/site-name/site-name';
@Component({
  selector: 'nav[app-main-menu]',
  imports: [MatDividerModule, Logo, SiteName, RouterModule],
  templateUrl: './main-menu.html',
  styleUrl: './main-menu.scss',
})
export class MainMenu implements OnInit {
  constructor(private productApi: ProductApiService) { }

  get newArrivalsNo(): string {
    return environment.collection.new_arrivals;

  }

  get bestSellersNo(): string {
    return environment.collection.best_sellers;
  }

  ngOnInit(): void {
    this.findProductCategories();
  }
  categories: ProductCategory[] = [];
  loading: boolean = false;
  async findProductCategories() {
    try {
      this.loading = true;
      this.categories = await this.productApi.findProductCategories();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
